import React from "react";
import loaderImg from "../images/loader.svg";
const Loader = () => {
  return <img src={loaderImg} alt="Loader" />;
};

export default Loader;
